import CarouselHeader from '@/components/FullPageCarousel/CarouselHeader';
import PostStatus from './PostStatus';

function Loader({ isLoading }: { isLoading: boolean }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background flex-col pb-[100px]">
      <CarouselHeader disabled={isLoading} />
      <div className="flex-grow flex items-center justify-center w-full">
        <div className="w-full max-w-2xl space-y-8 p-3">
          <div className="flex justify-center items-center space-x-2">
            <PostStatus isLoading />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
